import React from 'react'
import { createPopper } from "@popperjs/core";
import { QuestionMarkCircleIcon } from '@heroicons/react/outline';


function PainPopper() {

    const [popoverShow, setPopoverShow] = React.useState(false);
    const btnRef = React.createRef();
    const popoverRef = React.createRef();
    const openPopover = () => {
        createPopper(btnRef.current, popoverRef.current, {
        placement: "left"
        });
        setPopoverShow(true);
    };
    const closePopover = () => {
        setPopoverShow(false);
    };

    return (
        <>
      <div className="flex flex-wrap">
        <div className="w-full text-center">
          <button
          className=""
            type="button"
            onClick={() => {
              popoverShow ? closePopover() : openPopover();
            }}
            ref={btnRef}
          >
            <QuestionMarkCircleIcon className="h-4 my-1" />
          </button>
          <div
            className={
              (popoverShow ? "" : "hidden ") +
              "bg-" +
              "white" +
              " border-2 ml-3 block z-auto font-normal leading-normal text-sm max-w-xs text-left no-underline break-words rounded-lg"
            }
            ref={popoverRef}
          >
            <div className="p-1">
              {/* <div
                className={
                  "bg-" +
                  "white" +
                  "text-black font-semibold p-3 mb-0 border-b border-solid border-blueGray-100 uppercase rounded-t-lg"
                }
              >
                 popover title
              </div> */}
              <div className="text-black p-2">
                <b>Pain Examples</b>
              </div>
              <div className="text-black p-2">
                  <b>Zoom:</b> Most video chat software is really slow and unreliable, which means time is wasted on lagging calls and not conversations
              </div>
              <div className="text-black p-2">
                  <b>Slack:</b> Chatting with employees through email is really slow and time consuming.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
    )
}

export default PainPopper
